import React, { memo, useMemo } from "react"

import { useApp } from "../../hooks/useApp"

export const withHeaderAccount = Component =>
  memo(({ name = "HeaderAccount", activeHeaderHero, location }: any) => {
    const {
      config: {
        settings: { routes },
      },
      globalStateReducer,
    } = useApp()

    const [{ activeMenu }] = globalStateReducer

    const quizUrl = `${routes.QUIZ}`

    Component.displayName = name
    return useMemo(() => <Component activeMenu={activeMenu} activeHeaderHero={activeHeaderHero} quizUrl={quizUrl} location={location} />, [
      activeMenu,
      activeHeaderHero,
      quizUrl,
      location,
    ])
  })
